import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistGetProfileStatusRequest } from '@/shared/api/requests/artist/status/get/request';
import { artistGetProfileStatus } from '@/shared/api/requests/artist/status/get/request';

export const useArtistProfileStatusQuery = (
  params: ArtistGetProfileStatusRequest,
  settings?: QuerySettings<typeof artistGetProfileStatus>
) =>
  useQuery({
    queryKey: ['ArtistProfileStatus', params.profileId],
    queryFn: () =>
      artistGetProfileStatus({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
